import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContext";
import { getCars, createCar, updateCar, deleteCar } from "../api";

export default function AdminCars() {
    const { token, logout } = useContext(AuthContext);
    const [cars, setCars] = useState([]);
    const [error, setError] = useState("");
    const [newCar, setNewCar] = useState({ name: "", price: "", link: "", image: "", active: null });

    const load = async () => {
        try {
            const data = await getCars();
            setCars(Array.isArray(data) ? data : []);
        } catch (e) {
            if (e.message === "unauthorized") logout();
            else setError("Konnte Autos nicht laden.");
        }
    };

    useEffect(() => { load(); }, []);

    const fileToBase64 = (file, cb) => {
        const reader = new FileReader();
        reader.onload = e => cb(e.target.result.split(",")[1]);
        reader.readAsDataURL(file);
    };

    const save = async (c) => {
        try {
            await updateCar(token, c.id, c);
            load();
        } catch (e) {
            if (e.message === "unauthorized") logout();
            else setError("Speichern fehlgeschlagen.");
        }
    };

    const create = async () => {
        try {
            await createCar(token, newCar);
            setNewCar({ name: "", price: "", link: "", image: "", active: true });
            load();
        } catch (e) {
            if (e.message === "unauthorized") logout();
            else setError("Anlegen fehlgeschlagen.");
        }
    };

    const remove = async (id) => {
        try {
            await deleteCar(token, id);
            load();
        } catch (e) {
            if (e.message === "unauthorized") logout();
            else setError("Löschen fehlgeschlagen.");
        }
    };

    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-4">Fahrzeuge verwalten</h2>
            {error && <div className="text-red-600 mb-4">{error}</div>}
            <table className="w-full border">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="p-2 text-left">Bezeichnung</th>
                        <th className="p-2 text-left">Preis</th>
                        <th className="p-2 text-left">Link</th>
                        <th className="p-2 text-left">Aktiv</th>
                        <th className="p-2 text-left">Bild</th>
                        <th className="p-2"></th>
                    </tr>
                </thead>
                <tbody>
                    {cars.map(c => (
                        <tr key={c.id} className="border-t">
                            <td className="p-2">
                                <input
                                    value={c.name}
                                    onChange={e => setCars(cars.map(x => x.id === c.id ? { ...x, name: e.target.value } : x))}
                                    className="border p-1 w-full"
                                />
                            </td>
                            <td className="p-2">
                                <input
                                    type="number"
                                    value={c.price}
                                    onChange={e => setCars(cars.map(x => x.id === c.id ? { ...x, price: parseFloat(e.target.value) } : x))}
                                    className="border p-1 w-full"
                                />
                            </td>
                            <td className="p-2">
                                <input
                                    value={c.link}
                                    onChange={e => setCars(cars.map(x => x.id === c.id ? { ...x, link: e.target.value } : x))}
                                    className="border p-1 w-full"
                                />
                            </td>
                            <td className="p-2 text-center">
                                <input
                                    type="checkbox"
                                    checked={c.active}
                                    onChange={e => setCars(cars.map(x => x.id === c.id ? { ...x, active: e.target.checked } : x))}
                                />
                            </td>
                            <td className="p-2">
                                {c.image && <img src={`data:image/*;base64,${c.image}`} alt="" className="h-16 mb-1" />}
                                <input
                                    type="file"
                                    onChange={e => fileToBase64(e.target.files[0], b64 => setCars(cars.map(x => x.id === c.id ? { ...x, image: b64 } : x)))}
                                />
                            </td>
                            <td className="p-2 text-right">
                                <button onClick={() => save(c)} className="bg-blue-600 text-white px-3 py-1 rounded">Speichern</button>
                                <button onClick={() => remove(c.id)} className="bg-red-600 text-white px-3 py-1 rounded ml-2">Löschen</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="mt-4">
                <h3 className="font-bold mb-2">Neues Fahrzeug anlegen</h3>
                <div className="flex flex-col md:flex-row gap-2">
                    <input
                        value={newCar.name}
                        onChange={e => setNewCar({ ...newCar, name: e.target.value })}
                        placeholder="Bezeichnung"
                        className="border p-1 flex-1"
                    />
                    <input
                        type="number"
                        value={newCar.price}
                        onChange={e => setNewCar({ ...newCar, price: parseFloat(e.target.value) })}
                        placeholder="Preis"
                        className="border p-1 flex-1"
                    />
                    <input
                        value={newCar.link}
                        onChange={e => setNewCar({ ...newCar, link: e.target.value })}
                        placeholder="Link"
                        className="border p-1 flex-1"
                    />
                    <label className="flex items-center gap-1">
                        <input
                            type="checkbox"
                            checked={newCar.active}
                            onChange={e => setNewCar({ ...newCar, active: e.target.checked })}
                        />
                        Aktiv
                    </label>
                    <input
                        type="file"
                        onChange={e => fileToBase64(e.target.files[0], b64 => setNewCar({ ...newCar, image: b64 }))}
                        className="flex-1"
                    />
                    <button onClick={create} className="bg-green-600 text-white px-3 py-1 rounded">Hinzufügen</button>
                </div>
            </div>
        </div>
    );
}
